var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWayBottom(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    fill: "none",
    width: 24.377197265625,
    height: 33.747314453125,
    viewBox: "0 0 24.377197265625 33.747314453125",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,1,-1,0,11.683757781982422,-11.683757781982422)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 11.683757781982422,
    y1: -0.5,
    x2: 44.723758697509766,
    y2: -0.5,
    fillOpacity: 0,
    strokeOpacity: 1,
    stroke: "#666666",
    fill: "none",
    strokeWidth: 1,
    style: {
      mixBlendMode: "passthrough"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M12.183859765625,32.33269885559082L0.707462765625,20.84659485559082L0.00005676562500001037,21.55340285559082L12.183559765625,33.74729885559082L24.377359765625,21.553551855590822L23.670159765625,20.84644585559082L12.183859765625,32.33269885559082Z",
    fillRule: "evenodd",
    fillOpacity: 1,
    style: {
      mixBlendMode: "passthrough"
    }
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWayBottom);
export default __webpack_public_path__ + "static/media/way-bottom.12a2d947217d9048d496f7fb6db277dc.svg";
export { ForwardRef as ReactComponent };